<template>
    <div
        :class="[
            classes,
            small ? 'px-2 py-0.5 text-xxs' : 'px-1.5 pt-[3px] pb-[2px]',
            'mt-2 w-fit border border-current flex-shrink-0 flex items-center rounded-full',
        ]"
        v-text="text"
    />
</template>

<script>
export default {
    name: 'Tag',

    props: {
        text: {
            type: String,
            required: true,
        },
        classes: {
            required: false,
        },
        small: {
            type: Boolean,
            default: false,
        },
    },
}
</script>
